module.exports = __webpack_public_path__ + "img/tag-industrial-design.13f2fe25.svg";